/** Shared placement for bottom floating action buttons (right stack). */
export const FLOAT_ACTION_BOTTOM = 'bottom-20 md:bottom-6'
export const FLOAT_ACTION_SIZE = 'h-12 w-12'
/** WhatsApp sits one button height + gap above the back-to-top control. */
export const FLOAT_WHATSAPP_BOTTOM =
  'bottom-[calc(5rem+3rem+0.75rem)] md:bottom-[calc(1.5rem+3rem+0.75rem)]'
